export const GET_REWARDS = "GET_REWARDS";
export const GET_REWARDS_SUCCESS = "GET_REWARDS_SUCCESS";
export const GET_REWARDS_FAILED = "GET_REWARDS_FAILED";

export const SET_REWARD_DETAIL = "SET_REWARD_DETAIL";
